import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RedirectEventTypes } from '../../enum/redirect-event-type.enum';
import { AuthService } from 'src/app/Core/auth/services/auth/auth.service';
import { AnalyticsService } from 'src/app/Shared/_services/analytics/analytics.service';
import { ToastService } from '../../services/toast/toast.service';
import { Navigation } from 'src/app/_utlis/navigateToLanding';

import { StorageService } from 'src/app/Core/_services/storage/storage.service';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-redirect',
        standalone: true,
imports: [],
    templateUrl: './redirect.component.html',
    styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent {
  eventTypes = RedirectEventTypes;
  eventType!: string;
  isLoading: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private toastService: ToastService,
    private router: Router,
    private nav: Navigation,
    private storageService: StorageService,
    private analyticsService: AnalyticsService
  ) {
    this.route.queryParams.subscribe((params) => {
      this.eventType = params['eventType'];
      this.handleEvent(params);
    });
  }
  handleEvent(params: any) {
    this.isLoading = true;
    switch (this.eventType) {
      case RedirectEventTypes.VerifyMail:
        this.handleVerifyMail(params);
        break;
      case RedirectEventTypes.BuyerExclusiveInvitation:
        this.handleBuyerExclusiveInvitation(params);
        break;

      case RedirectEventTypes.BuyerAuctionCatalog:
        this.handleAuctionCatalogue(params);
        break;
      case RedirectEventTypes.AuctionItemProfile:
        this.handleAuctionItemProfile(params);
        break;

      case RedirectEventTypes.SellerAskForMoreDocumentsFromBuyer:
        this.handleSellerAskForMoreDocumentsFromBuyer(params);
        break;

      case RedirectEventTypes.BuyerAcceptAuctionInvitation:
        this.handleBuyerAcceptAuctionInvitation(params);
        break;

      case RedirectEventTypes.ForgetPassword:
        this.handleForgetPassword(params);
        break;

      case RedirectEventTypes.Login:
        this.handleLogin(params);
        break;

      case RedirectEventTypes.BuyerToSellerApplication:
        this.handleBuyerToSellerApplication(params);
        break;

      case RedirectEventTypes.SellerTermsAndConditions:
        this.handleSellerTermsAndConditions(params);
        break;
      case RedirectEventTypes.BuyerHorseClaimer:
        this.handleBuyerHorseClaimer(params);
        break;
      case RedirectEventTypes.SellerBuyerApplication:
        this.handleBuyerToSellerApplication(params);
        break;
      case RedirectEventTypes.SellerInvoice:
        this.handleSellerInvoice(params);
        break;
      case RedirectEventTypes.SellerOffers:
        this.handleSellerOffers(params);
        break;
    }
  }
  //VerifyMail
  handleVerifyMail(params: any) {
    const { mail, code, userType } = this.getPayload(params).payload;
    // this.routeToLogin(userType)

    this.authService
      .verifyEmail({ email: mail, code, userType, redirect: 1 })
      .subscribe(
        (res) => {
          // Track email verified
          // this.analyticsService.trackEmailVerification('verified', userType as 'buyer' | 'seller');
          this.routeToLogin(userType);
          // //check success msg
          this.toastService.showSuccess(res.data.message);
          this.isLoading = false;
        },
        (err) => {
          this.toastService.showError(err.error.Error[0]);

          // if (userType == 'buyer') {
          //   this.router.navigate(['/buyer/auth']);
          // } else if (userType == 'seller') {
          //   this.router.navigate(['/seller/auth']);
          // } else {
          //   NavigateToLanding();
          // }
          this.routeToLogin(userType);
          this.isLoading = false;
        }
      );
  }
  routeToLogin(userType: string) {
    if (userType == 'buyer') {
      this.router.navigate(['/buyer/auth']);
    } else if (userType == 'seller') {
      this.router.navigate(['/seller/auth']);
    } else {
      this.nav.NavigateToLanding();
    }
  }

  //BuyerExclusiveInvitation

  handleBuyerExclusiveInvitation(params: any) {
    const { seller_user_id } = this.getPayload(params).payload;

    this.router.navigate(['buyer/exclusive-invitation', seller_user_id]);
  }
  // BuyerAuctionCatalog
  handleBuyerAuctionCatalog(params: any) {}

  //SellerAskForMoreDocumentsFromBuyer
  handleSellerAskForMoreDocumentsFromBuyer(params: any) {
    const { notificationID, redirect_action_type, requestID } =
      this.getPayload(params).payload;
    if (requestID) {
      this.router.navigate(['/buyer/account/profile'], {
        queryParams: {
          openUpload: 1,
          requestID,
          redirect_action_type,
        },
      });
    }
  }

  //BuyerAcceptAuctionInvitation
  handleBuyerAcceptAuctionInvitation(params: any) {
    const payload = this.getPayload(params).payload;
    this.authService.buyerAcceptInvitation({ ...payload }).subscribe(
      (res) => {
        // Track invitation accepted
        // this.analyticsService.trackAcceptInvitation(payload.auction_id);
        this.router.navigate(['buyer/auctions', payload.auction_slug]);
      },
      (err) => {
        this.toastService.showError(err.error.Error[0]);
      }
    );
  }

  // ForgetPassword

  handleForgetPassword(params: any) {
    const { email, code, UserType } = this.getPayload(params).payload;
    let url = '';
    if (UserType == 'seller') {
      url = '/seller/auth/password-reset';
    } else {
      url = '/buyer/auth/password-reset';
    }
    this.router.navigate([url], {
      queryParams: {
        email,
        code,
        UserType,
      },
    });
    // const { notificationID, redirect_action_type, requestID } = this.getPayload(params).payload;
  }

  // Login
  handleLogin(params: any) {
    const { mail, code, userType } = this.getPayload(params).payload;

    this.router.navigate(
      [userType, 'auth', 'login']
      // ,{
      // queryParams:{
      //   email,code,UserType

      // }
      // }
    );
  }
  // buyer/auctions/new-auction-344/horse/horse-505
  handleAuctionItemProfile(params: any) {
    const { auction_id, auction_slug, auction_item_id, auction_item_slug } =
      this.getPayload(params).payload;
    this.router.navigate(
      ['buyer/auctions', auction_slug, 'horse', auction_item_slug],
      {
        queryParams: {
          type: 'catalogue',
        },
      }
    );
  }

  handleBuyerToSellerApplication(params: any) {
    const payloadData = this.getPayload(params).payload;
    const buyerId = payloadData.buyer_user_id || payloadData.buyerID;
    if (buyerId) {
      this.router.navigate(['seller/buyer-applications', buyerId]);
    } else {
      this.toastService.showError('Invalid buyer ID');
    }
  }

  getPayload(input: any) {
    const result: any = {
      payload: {},
    };

    const hasPayloadFormat = Object.keys(input).some(
      (key) => key.startsWith('payload[') && key.endsWith(']')
    );

    if (hasPayloadFormat) {
      // Handle payload format
      for (const key in input) {
        if (input.hasOwnProperty(key)) {
          if (key.startsWith('payload[') && key.endsWith(']')) {
            const propName = key.slice(8, -1);
            result.payload[propName] = input[key];
          }
        }
      }
    } else {
      // Handle direct params format
      const { eventType, ...params } = input;
      result.payload = params;
    }
    return result;
  }

  handleSellerTermsAndConditions(params: any) {
    const { redirect_action_type, seller_id, terms_and_condition_id } =
      this.getPayload(params).payload;
    this.router.navigate([
      'terms-and-conditions/terms',
      terms_and_condition_id,
    ]);
  }

  handleBuyerHorseClaimer(params: any) {
    const { horseClaimerID } = this.getPayload(params).payload;

    if (horseClaimerID) {
      localStorage.setItem(this.storageService.getPrefixedKey('showHorseClaimerDialog'), 'true');
      localStorage.setItem(this.storageService.getPrefixedKey('horseClaimerID'), horseClaimerID);
      this.router.navigate(['/buyer/account/my-horses']);
    } else {
      this.toastService.showError('Invalid horse claimer ID');
    }
  }
  handleAuctionCatalogue(params: any) {
    const { auctionID } = this.getPayload(params).payload;
    if (auctionID) {
      this.router.navigate(['/buyer/auctions/id', auctionID]);
    }
  }
  handleSellerInvoice(params: any) {
    const { invoiceID } = this.getPayload(params).payload;
    if (invoiceID) {
      const tab = 'fee-invoices';
      this.router.navigate(['/seller/payments-history'], {
        queryParams: { tab, invoiceID },
      });
    }
  }
  handleSellerOffers(params: any) {
    const tab = 'offers';
    this.router.navigate(['/seller/horses/list'], {
      queryParams: {
        tab: tab,
        subtab: this.route.snapshot.queryParams['subtab'] || 'all-offers',
      },
      queryParamsHandling: 'merge', // Preserve other query params if any
    });
  }
}
